// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.risk img[data-v-3963c21c] {\n  width: 100%;\n  margin: 0 auto;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
